import tradingContent from "./content/trading.json";

export const tradingMock = {
  name: "trading",
  layoutType: 1,
  areasList: [
    {
      id: "trading-1",
      name: "trading-content",
      componentName: "Comp:TradingPage",
      content: JSON.stringify(tradingContent),
    },
  ],
};
